export const adminNavigationStyles = (isActive) => ({
  minWidth: 0,
  minHeight: 36,
  px: 1.5,
  py: 0.75,
  borderRadius: 2,
  fontSize: "0.875rem",
  fontWeight: 500,
  lineHeight: 1.5,
  textTransform: "none",
  whiteSpace: "nowrap",
  color: isActive ? "text.primary" : "text.secondary",
  backgroundColor: isActive ? "action.selected" : "transparent",
  "&:hover": {
    backgroundColor: "action.hover",
    color: "text.primary",
  },
  "& .MuiButton-startIcon": {
    ml: 0,
    mr: 0.75,
  },
  "& .MuiButton-startIcon .MuiSvgIcon-root": {
    fontSize: 18,
  },
  "& .MuiBadge-badge": {
    fontSize: "0.625rem",
    minWidth: 16,
    height: 16,
    px: 0.5,
  },
});
